import './_styles.scss';
import React from "react";
import { Rating } from "components";
import ProductInformation from './_information';

const ProductRating = ({ rating=0 }) => (
  <div className="value">
    <Rating score={rating}/>
    <span className='link'>{`${rating} reviews`}</span>
  </div>
)

export default ({ product }) => (
  <div className='Product-Details-Body'>

    <div className="Section">
      <div className="Section-Heading">Product Information</div>
      <ProductInformation
        values={product.attributes.concat({
          raw: true,
          name: 'Customer Reviews',
          value: <ProductRating rating={product.rating}/>
        })}
      />
    </div>

  </div>
)
